// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__ASFrp","desktop":"styles_desktop__ReV8x","flex":"styles_flex__k4uwk"};